import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.httpService';
import { handleErrorMessage } from 'src/app/shared/operators/error.operator';
import { IBasicSearchProps } from 'src/app/shared/models/dynamic.model';
import { URLConstants } from 'src/app/shared/utility/url-constants';
import { StatusCodeCreateUpdatePayload } from '../components/status-codes/status-codes.model';
import {
  ApplyBulkPodPayload,
  ManifestPodApiResponse,
  ManifestPodPreview,
  ManifestPodSnapshot,
} from '../model/hawb.model';

@Injectable({
  providedIn: 'root',
})
export class StatusCodesService {
  public requiredStatusCodeDataForInfoPage = new BehaviorSubject<any>({});
  public statusCodeId = new BehaviorSubject<number>(0);
  public statuCodeFormReadMode = new BehaviorSubject<boolean>(false);
  public isStatusActionSucceededData = new BehaviorSubject<boolean>(false);

  private readonly baseService = inject(BaseService);
  private readonly errorHandler = handleErrorMessage();

  public statusCodesBasicSearch(payload: IBasicSearchProps): Observable<any> {
    return this.baseService
      .initiateApiRequest(
        'POST',
        URLConstants.basicSearchStatusCodes,
        payload,
        '',
        'json'
      )
      .pipe(this.errorHandler());
  }

  public saveStatusCode(
    payload: StatusCodeCreateUpdatePayload
  ): Observable<any> {
    return this.baseService
      .initiateApiRequest(
        'POST',
        URLConstants.addOrUpdateStatusCode,
        payload,
        'json'
      )
      .pipe(this.errorHandler());
  }

  public setRequiredDataForStatusCodeInfoPage(data: any): void {
    this.requiredStatusCodeDataForInfoPage.next(data);
  }

  public deleteStatusCode(payload: any): Observable<any> {
    return this.baseService
      .initiateApiRequest(
        'POST',
        URLConstants.deleteStatusCode,
        payload,
        'json'
      )
      .pipe(this.errorHandler());
  }

  public setStatusCode(statusCode: number) {
    this.statusCodeId.next(statusCode);
  }

  public setStatusCodeInfoFormReadMode(data: boolean) {
    this.statuCodeFormReadMode.next(data);
  }

  public isStatusActionSucceeded(data: boolean) {
    this.isStatusActionSucceededData.next(data);
  }

  public saveViewStatusCode(payload: any): Observable<any> {
    return this.baseService
      .initiateApiRequest(
        'PUT',
        URLConstants.createStatusCode,
        payload,
        'json'
      )
      .pipe(this.errorHandler());
  }

  public updateViewStatusCode(payload: any): Observable<any> {
    return this.baseService
      .initiateApiRequest(
        'POST',
        URLConstants.updateStatusCode,
        payload,
        'json'
      )
      .pipe(this.errorHandler());
  }

  public deleteViewStatusCode(payload: any): Observable<any> {
    return this.baseService
      .initiateApiRequest(
        'POST',
        URLConstants.deleteViewStatusCode,
        payload,
        'json'
      )
      .pipe(this.errorHandler());
  }

  public applyBulkPod(payload: ApplyBulkPodPayload): Observable<any> {
    return this.baseService
      .initiateApiRequest(
        'POST',
        URLConstants.bulkPodStatusCode,
        payload,
        'json'
      )
      .pipe(this.errorHandler());
  }

  public getManifestPodShipments(
    manifestId: number
  ): Observable<ManifestPodApiResponse<ManifestPodPreview>> {
    return this.baseService
      .initiateApiRequest(
        'GET',
        `${URLConstants.manifestPod}/${manifestId}/shipments`,
        '',
        'json'
      )
      .pipe(this.errorHandler());
  }

  public getManifestPodLinkedShipments(
    statusCodeInfoId: number
  ): Observable<ManifestPodApiResponse<ManifestPodSnapshot>> {
    return this.baseService
      .initiateApiRequest(
        'GET',
        `${URLConstants.manifestPod}/${statusCodeInfoId}/linkedShipments`,
        '',
        'json'
      )
      .pipe(this.errorHandler());
  }
}
